import Logger from '../../tools/Logger';

const log = Logger.child({ component: 'Error' });

interface NonStandardErrorProperties {
  fileName?: string; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/fileName
  lineNumber?: number; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/lineNumber
  columnNumber?: number; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/columnNumber
}

class BaseError extends Error implements NonStandardErrorProperties {
  fileName?: string;
  lineNumber?: number;
  columnNumber?: number;

  constructor(name = 'BaseError', message: string, fileName?: string, lineNumber?: number) {
    super(message);
    this.name = name;

    this.fileName = fileName;
    this.lineNumber = lineNumber;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BaseError);
    }

    log.error(`${name}: ${message}`);

    return this;
  }
}

export default BaseError;
